import React from 'react';
import PolicyLayout from '../../components/seo/PolicyLayout';

const PrivacyPolicy = () => {
  return (
    <PolicyLayout 
      title="Privacy Policy" 
      subtitle="Informativa sulla Privacy di Molinaro Immobiliare"
      lastUpdated="10 Giugno 2025"
    >
      <h3>Introduzione</h3>
      <p>
        Molinaro Immobiliare (di seguito "noi", "nostro" o "Molinaro Immobiliare") con sede in Via Pisana 327, 50018 Scandicci (FI),
        in qualità di titolare del trattamento dei dati, si impegna a proteggere la tua privacy. 
        Questa informativa sulla privacy descrive come raccogliamo, utilizziamo e proteggiamo i tuoi dati personali 
        quando utilizzi il nostro sito web molinaroimmobiliare.it e i nostri servizi.
      </p>
      
      <h3>Dati personali che raccogliamo</h3>
      <p>
        Raccogliamo diversi tipi di informazioni personali, tra cui:
      </p>
      <ul>
        <li>
          <strong>Dati identificativi:</strong> Nome, cognome, indirizzo, numero di telefono, indirizzo email, codice fiscale e partita IVA.
        </li>
        <li>
          <strong>Dati immobiliari:</strong> Informazioni relative agli immobili che intendi vendere, acquistare o affittare.
        </li>
        <li>
          <strong>Dati di navigazione:</strong> Indirizzo IP, dati di localizzazione, informazioni sul dispositivo e browser utilizzato.
        </li>
        <li>
          <strong>Dati di utilizzo:</strong> Informazioni su come interagisci con il nostro sito, servizi e comunicazioni.
        </li>
      </ul>
      
      <h3>Come raccogliamo i tuoi dati</h3>
      <p>
        Raccogliamo i tuoi dati personali quando:
      </p>
      <ul>
        <li>Compili i moduli di contatto sul nostro sito web</li>
        <li>Ti iscrivi alla nostra newsletter</li>
        <li>Richiedi informazioni su un immobile</li>
        <li>Ci contatti telefonicamente o via email</li>
        <li>Visiti il nostro sito web (attraverso cookie e tecnologie simili)</li>
        <li>Interagisci con i nostri profili sui social media</li>
        <li>Ci affidi un mandato per la vendita o la locazione di un immobile</li>
      </ul>
      
      <h3>Finalità del trattamento dei dati</h3>
      <p>
        Utilizziamo i tuoi dati personali per le seguenti finalità:
      </p>
      <ul>
        <li>Fornirti i servizi immobiliari richiesti (valutazioni, visite, assistenza nella compravendita)</li>
        <li>Rispondere alle tue richieste di informazioni</li>
        <li>Inviarti la nostra newsletter e comunicazioni di marketing (solo con il tuo consenso)</li>
        <li>Adempiere agli obblighi legali e fiscali</li>
        <li>Migliorare il nostro sito web e i nostri servizi</li>
        <li>Prevenire frodi e proteggerci legalmente</li>
      </ul>
      
      <h3>Base giuridica del trattamento</h3>
      <p>
        Il trattamento dei tuoi dati personali è basato su una o più delle seguenti basi giuridiche:
      </p>
      <ul>
        <li>L'esecuzione di un contratto di cui sei parte o di misure precontrattuali adottate su tua richiesta</li>
        <li>Il nostro legittimo interesse come agenzia immobiliare</li>
        <li>L'adempimento di obblighi legali a cui siamo soggetti</li>
        <li>Il tuo consenso esplicito per finalità specifiche (come l'invio di comunicazioni di marketing)</li>
      </ul>
      
      <h3>Conservazione dei dati</h3>
      <p>
        Conserviamo i tuoi dati personali solo per il tempo necessario al conseguimento delle finalità per cui sono stati raccolti, 
        inclusa la conformità a qualsiasi obbligo legale, contabile o di reportistica.
      </p>
      <p>
        In generale, i dati relativi alle transazioni immobiliari vengono conservati per 10 anni, come richiesto dalla normativa fiscale italiana. 
        I dati raccolti per finalità di marketing vengono conservati fino alla revoca del tuo consenso.
      </p>
      
      <h3>Condivisione dei dati</h3>
      <p>
        Possiamo condividere i tuoi dati personali con:
      </p>
      <ul>
        <li>Fornitori di servizi (per esempio, software di gestione immobiliare, consulenti IT, commercialista)</li>
        <li>Notai e altri professionisti coinvolti nelle transazioni immobiliari</li>
        <li>Autorità pubbliche quando richiesto dalla legge</li>
        <li>Potenziali acquirenti o venditori quando necessario per fornire i nostri servizi immobiliari</li>
      </ul>
      <p>
        Non vendiamo, noleggiamo o cediamo i tuoi dati personali a terzi per finalità di marketing. Ci assicuriamo che tutti i nostri 
        fornitori di servizi trattino i tuoi dati in modo sicuro e conforme al GDPR.
      </p>
      
      <h3>I tuoi diritti sulla privacy</h3>
      <p>
        Ai sensi del Regolamento Generale sulla Protezione dei Dati (GDPR), hai i seguenti diritti:
      </p>
      <ul>
        <li>Diritto di accesso ai tuoi dati personali</li>
        <li>Diritto di rettifica dei dati inesatti</li>
        <li>Diritto alla cancellazione dei tuoi dati ("diritto all'oblio")</li>
        <li>Diritto di limitazione del trattamento</li>
        <li>Diritto alla portabilità dei dati</li>
        <li>Diritto di opposizione al trattamento</li>
        <li>Diritto di revoca del consenso in qualsiasi momento</li>
        <li>Diritto di presentare un reclamo all'autorità di controllo (Garante per la Protezione dei Dati Personali)</li>
      </ul>
      <p>
        Per esercitare questi diritti, puoi contattarci all'indirizzo email privacy@molinaroimmobiliare.it o per posta all'indirizzo 
        della nostra sede.
      </p>
      
      <h3>Sicurezza dei dati</h3>
      <p>
        Adottiamo adeguate misure di sicurezza tecniche e organizzative per proteggere i tuoi dati personali contro l'accesso non autorizzato, 
        la perdita o la distruzione accidentale. Queste misure includono:
      </p>
      <ul>
        <li>Crittografia dei dati sensibili</li>
        <li>Controlli degli accessi ai nostri sistemi informatici</li>
        <li>Backup regolari dei dati</li>
        <li>Formazione del personale sulle pratiche di sicurezza dei dati</li>
      </ul>
      
      <h3>Trasferimenti internazionali di dati</h3>
      <p>
        I tuoi dati personali sono archiviati e trattati principalmente all'interno dell'Unione Europea. 
        Tuttavia, alcuni dei nostri fornitori di servizi potrebbero essere situati al di fuori dell'UE. 
        In questi casi, ci assicuriamo che il trasferimento dei dati avvenga nel rispetto della normativa 
        europea sulla protezione dei dati, attraverso l'adozione di clausole contrattuali standard approvate 
        dalla Commissione Europea o altri meccanismi adeguati.
      </p>
      
      <h3>Modifiche alla nostra Privacy Policy</h3>
      <p>
        Ci riserviamo il diritto di modificare questa informativa sulla privacy in qualsiasi momento. 
        La versione aggiornata sarà sempre disponibile sul nostro sito web, con la data dell'ultima revisione. 
        Ti invitiamo a consultare regolarmente questa pagina per essere sempre informato sulle nostre pratiche di privacy.
      </p>
      
      <h3>Contattaci</h3>
      <p>
        Se hai domande o preoccupazioni riguardo la nostra Privacy Policy o il trattamento dei tuoi dati personali, 
        non esitare a contattarci:
      </p>
      <p>
        <strong>Molinaro Immobiliare</strong><br />
        Via Pisana 327<br />
        50018 Scandicci (FI)<br />
        Email: privacy@molinaroimmobiliare.it<br />
        Telefono: +39 327 8855115
      </p>
    </PolicyLayout>
  );
};

export default PrivacyPolicy;